import { FC } from 'react'

interface Props {
  size?: number
  className?: string
}

export const TikTokIcon: FC<Props> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="-2 -1 22 22"
    fill="none"
    className={className}
  >
    <path
      d="M13.0742 0C13.4042 2.83809 14.9882 4.53015 17.7423 4.71015V7.90226C16.1463 8.05826 14.7482 7.53624 13.1222 6.55221V12.5224C13.1222 20.1067 4.8539 22.4767 1.52979 17.0406C-0.606279 13.5424 0.701764 7.40424 7.55399 7.15823V10.5243C7.03197 10.6083 6.47395 10.7403 5.96393 10.9144C4.43988 11.4304 3.57586 12.3964 3.81586 14.1005C4.27788 17.3646 10.2661 18.3306 9.76806 11.9524V0.00600019H13.0742V0Z"
      fill="white"
    />
  </svg>
)
